import React,{ useEffect } from 'react';
import "./RenderTableStyle.css";
import { LoadingSpinerGif, Sx_Download } from "../../../../assets/icons";
import { MdOutlineFileDownload } from "react-icons/md";
import { RiDeleteBinLine, RiLineHeight } from "react-icons/ri";
import { LuVideo } from "react-icons/lu";

import { getAspectRatio, getfpsFromNumAndDen,  getRenderStatus,  getResolutionFromHeightAndWidth } from "../render.constants";

import { useDispatch, useSelector } from "react-redux";
import { deleteAllRenders, deleteRenders,  downloadCardRender,  downloadRender,  getProjectDetails } from "../../../../Redux/actions/projectActions";

import { toast } from "react-toastify";
import socket from "../../../../socket";
    
const RendersTable = () => {

    const dispatch = useDispatch();
  
    const { isLoading, isCard,  renders,  _id: projectId, members, } = useSelector((state) => state?.project || {});
    // console.log(' renders History => ',renders);

    useEffect(() => {
        if (!projectId) return;

        const joinProjectRoom = () => {
            socket.emit("join-project-room", { projectId });
        };

        const handleRenderUpdate = (data) => {
            if (data?.projectId && String(data.projectId) !== String(projectId)) {
                return;
            }
            dispatch(getProjectDetails(projectId, isCard));
        };

        if (!socket.connected) socket.connect();
        if (socket.connected) joinProjectRoom();
        socket.on("connect", joinProjectRoom);
        socket.on("render-update", handleRenderUpdate);

        return () => {
            socket.off("connect", joinProjectRoom);
            socket.off("render-update", handleRenderUpdate);
        };
    }, [projectId, isCard, dispatch]);

    const downLoadVideo = async (renderId) => {
        const urlRes = isCard  ? await dispatch(downloadCardRender(projectId, renderId))  : await dispatch(downloadRender(projectId, renderId));
        if (urlRes?.success) {
        window.open(urlRes?.data?.downloadURL);
        } else {
        toast.error("URL Not Exist");
        }
    };

    const deleteRender = (renderId) => {
        if (window.confirm(`Are you sure you want to delete Render (${renderId})?`)) {
            dispatch(deleteRenders(projectId, renderId, isCard));
        }
    };

    const clearHistory = async () => {
        if (window.confirm("Are you sure you want to delete All Renders?")) {
        const res = await dispatch(deleteAllRenders(projectId));
        toast.success(res?.message);
        }
    };

    useEffect(() => {
        dispatch(getProjectDetails(projectId, isCard));
    }, [projectId]);

    return (
        <div className='w-full flex flex-col  border-[rgba(255,255,255,.01)]  relative overflow-hidden renderpage-TableContainer' >
            
            <div className='flex items-center renderpage-titleBox '>
                <LuVideo className="text-[#c4b2ff]"  size={25} />
                <h1 className="renderpage-title">Render History{" "}</h1>
            </div>

            <div className="space-y-1 h-full overflow-y-auto custom-scrollbar renderpage-tblBox overflow-y-auto">

                {renders?.length > 0 ? (
                    renders?.map((render, idx) => {
                    // console.log('render table => ',render);
                    return (
                        render && (                                  
                            <div key={idx} className='bg-[rgba(255,255,255,.02)] border-[rgba(255,255,255,.06)] rounded-xl flex  md:flex-row items-start md:items-center justify-between transition-colors hover:bg-[rgba(255,255,255,.03)] renderpage-tblrow'>

                                <div className='flex flex-col gap-1.5'>

                                    <div className='flex items-center gap-3 tblrow-itms tblrow-itms1' >
                                        <p className='' style={{}}><span className='text-white subtext font-[500]'>V</span><span className='text-white text-[18px] font-[500]'>{renders.length - idx }</span></p>                                        

                                        { !render?.isRederFinished && !render?.isVideoGenerated ? (
                                            <div className="inline-flex items-center tblrow-itms req-class gap-2">
                                                <span className="w-4 h-4 border-4 border-[rgba(124,92,255,.2)] border-t-[#3f7fde] rounded-full animate-spin "></span> 
                                                {getRenderStatus(render)}</div>
                                        ) : ( 
                                            <span className="inline-flex items-center tblrow-itms status-class">{getRenderStatus(render)}</span>
                                        ) } 
                                        
                                        <span className='text-[#625e83] gap-1 tblrow-itms flex justify-between items-center rndrexprtdt'>
                                            {new Date(render?.createdAt).toDateString()}
                                            <span className='flex w-1 h-1 rounded-full bg-[#625e83]'></span>
                                            {new Date(render?.createdAt).toTimeString()?.slice(0, 5)}   
                                        </span>
                                    </div>

                                    <div className="flex items-center gap-3 mt-1 text-sm text-[#a8a4c8] tblrow-itms2">

                                        <span className=''>{getResolutionFromHeightAndWidth(render?.videoHeight, render?.videoWidth)}</span>

                                        <div className='w-2 h-2 rounded-full bg-[#625e83]'></div>

                                        <span className="">{render?.format?.replace(/^output/, "")}</span>

                                        <div className='w-2 h-2 rounded-full bg-[#625e83]'></div>

                                        <span className=''>{getfpsFromNumAndDen(render?.fpsNumerator,  render?.fpsDenominator)}</span>

                                        <div className='w-2 h-2 rounded-full bg-[#625e83]'></div>

                                        <span className=''>{getAspectRatio( render?.videoWidth, render?.videoHeight)} Ratio</span>

                                        {!isCard && render?.scrollPixelPerFrame != null ? (
                                          <>
                                            <div className='w-2 h-2 rounded-full bg-[#625e83]'></div>
                                            <span className=''>{render.scrollPixelPerFrame} px/frame</span>
                                          </>
                                        ) : null}

                                    </div>


                                </div>

                                <div className='flex items-center gap-3 pr-[15px]' style={{ paddingRight: "5px" }}>
                                    {render?.isVideoGenerated ? (
                                        <button className='flex-1 md:flex-none flex items-center justify-center gap-2 bg-[rgba(255,255,255,.05)] hover:bg-[rgba(255,255,255,.1)] disabled:opacity-50 disabled:cursor-not-allowed  border-[rgba(255,255,255,.1)] text-white transition-colors rnder-downloadbutton' type='button' onClick={() => downLoadVideo(render._id)}><MdOutlineFileDownload size={20} /> Download</button>
                                    ) : (
                                        <div className='flex-1 md:flex-none flex items-center justify-center gap-2 bg-[rgba(255,255,255,.05)] hover:bg-[rgba(148, 72, 72, 0.1)] disabled:opacity-50 disabled:cursor-not-allowed  border-[rgba(255,255,255,.1)] text-white transition-colors rnder-downloadbutton cursor-default cursor-progress'><img className="w-5 h-5" size={25} src={LoadingSpinerGif} alt="" /> In-Progress</div>
                                    )}
                                   
                                    <button className="p-2 text-[#625e83] hover:text-red-400 hover:bg-red-400/10 rounded-lg transition-colors border-transparent hover:border-red-400/20" onClick={() => deleteRender(render?._id)}><RiDeleteBinLine size={20} /></button>
                                </div>

                            </div>                                  
                        )
                    );
                })
                ) : (

                    <div className='bg-[rgba(255,255,255,.02)] border-[rgba(255,255,255,.06)] rounded-2xl flex flex-col justify-center items-center  gap-2  transition-colors hover:bg-[rgba(255,255,255,.03)] renderpage-emptytblBox'>
                    
                        <dev className="w-16 h-16 rounded-full bg-[rgba(124,92,255,.1)] flex items-center justify-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor"  stroke-width="2"  stroke-linecap="round" stroke-linejoin="round"  class="lucide lucide-file-box w-8 h-8 text-[#7c5cff]">

                                <path d="M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"></path>
                                <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                                <path d="M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z"></path>
                                <path d="M7 17v5"></path>
                                <path d="M11.7 14.2 7 17l-4.7-2.8"></path>
                            </svg>
                        </dev>

                        <h1 className="renderpage-title">No Renders Yet</h1>

                        <p className="text-center max-w-[30rem] flex items-center cursor-pointer text-[#625e83] hover:text-white transition-colors select-none notifyEmailText">Your exported video renders will appear here. Start your first render to see it in the history. </p>

                    </div>

                )}

                {/* <table className="relative" width="100%">
                    <thead className="h-[55px] w-full  text-white sticky top-0 shadow-md">
                        <tr className="text-xl drop-shadow-2xl ">
                            <th className="h-[55px] leading-[55px] ">Version</th>
                            <th className="h-[55px] leading-[55px]">Created</th>
                            <th className="h-[55px] leading-[55px]">Resolution</th>
                            <th className="h-[55px] leading-[55px]">Format</th>
                            <th className="h-[55px] leading-[55px]">FPS</th>
                            <th className="h-[55px] leading-[55px]">Aspect Ratio</th>
                            <th className="h-[55px] leading-[55px]">Status</th>
                            <th className="h-[55px] leading-[55px]">Download</th>
                            <th className="h-[55px] leading-[55px]">Delete</th>
                        </tr>
                    </thead>                
                    <tbody className="text-lg">
                        {renders?.map((render, idx) => {
                            console.log('render table => ',render);
                            return (
                                render && (
                                    <tr key={idx} className={`${idx % 2 === 0 ? "" : ""}`}>
                                        <td>{idx + 1}</td>
                
                                        <td>{new Date(render?.createdAt).toDateString()} - {" "} {new Date(render?.createdAt).toTimeString()?.slice(0, 5)}</td>
                
                                        <td>{getResolutionFromHeightAndWidth(render?.videoHeight, render?.videoWidth)}</td>
                
                                        <td>{render?.format}</td>
                
                                        <td>{getfpsFromNumAndDen(render?.fpsNumerator, render?.fpsDenominator)}</td>
                
                                        <td>{render?.aspectRatio}</td>
                
                                        <td>{getRenderStatus(render)}</td>
                
                                        <td>
                                        {render?.isVideoGenerated ? (
                                            <span className="cursor-pointer flex items-center justify-center"  onClick={() => downLoadVideo(render._id)}><img className="w-7" src={Sx_Download} alt="" /></span>
                                        ) : (
                                            <span className="flex items-center justify-center"><img className="w-7" src={LoadingSpinerGif} alt="" /></span>
                                        )}
                                        </td>
                
                                        <td><span className="cursor-pointer" onClick={() => deleteRender(render?._id)}><RiDeleteBinLine className="inline" size={20} /></span></td>
                                  </tr>
                                )
                            );
                        })}
                    </tbody>
                </table> */}

            </div>

        </div>
    )
}
    
export default RendersTable;